'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draggableDimensionPublisher = require('./draggable-dimension-publisher');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_draggableDimensionPublisher).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/draggable-dimension-publisher/index.js
// module id = 3261
// module chunks = 0